// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-project-project-desktop-image----project-desktop-image-module---wrapper---2wP7c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-desktop-image/project-desktop-image.module.css
// module id = 513
// module chunks = 140935043865547